import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type RcpaxaPricingVersionFormat = PricingVersionFormat<'fr-rcp-axa'>

export const rcpaxaPricingVersions = [
  ['pricing-fr-rcp-axa-1.0.0-2025-12-22', { label: 'Version 1' }],
] as const satisfies PricingVersionTuple<RcpaxaPricingVersionFormat>[]

export type RcpaxaPricingVersion = (typeof rcpaxaPricingVersions)[number][0]
